"use client";

import FindByReg from "./FindByReg";
import { memo, useState } from "react";
import FindByManual from "./FindByManual";
import ToggleBtnGroup from "./ToggleBtnGroup";
import { useManualVehicle } from "@/lib/hooks/useManualVehicle";

const MemoToggleBtnGroup = memo(ToggleBtnGroup);

const VehicleForm = ({ t }) => {
  const [byModel, setByModel] = useState(false);
  const {
    data: { control, isDisabled, isFetching, optionsList, hasEngineOpts },
    methods: {
      register,
      handleSubmit,
      findManually,
      findUsingReg,
      resetFormData,
      fetchDetailByManual,
      handleDropdownSelection,
    },
  } = useManualVehicle({ t, isManualForm: byModel, manualSearch: true });

  const resetVehicleForm = (isByModel) => {
    resetFormData();
    setByModel(isByModel);
  };

  return (
    <>
      <MemoToggleBtnGroup
        t={t}
        byModel={byModel}
        resetVehicleForm={resetVehicleForm}
      />

      {byModel ? (
        <FindByManual
          t={t}
          control={control}
          isFetching={isFetching}
          isDisabled={isDisabled}
          optionsList={optionsList}
          findManually={findManually}
          handleSubmit={handleSubmit}
          hasEngineOpts={hasEngineOpts}
          fetchDetailByManual={fetchDetailByManual}
          handleDropdownSelection={handleDropdownSelection}
        />
      ) : (
        <FindByReg
          t={t}
          register={register}
          isFetching={isFetching}
          handleSubmit={handleSubmit}
          findUsingReg={findUsingReg}
        />
      )}
    </>
  );
};

export default VehicleForm;
